import { render } from "./AttendanceMonitoring.vue?vue&type=template&id=7adb0c5a"
import script from "./AttendanceMonitoring.vue?vue&type=script&lang=ts"
export * from "./AttendanceMonitoring.vue?vue&type=script&lang=ts"

import "./AttendanceMonitoring.vue?vue&type=style&index=0&id=7adb0c5a&lang=css"
script.render = render

export default script